export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_tr.89bc04dd14cf4660.json"